import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

function Navbar() {
  const token = localStorage.getItem('access_token');
  const navigate = useNavigate();

  const handleLogout = () => {
    // Remove the JWT token from localStorage
    localStorage.removeItem('access_token');
    // Redirect to login page
    navigate('/login');
  };

  return (
    <nav className="bg-indigo-700 p-4 shadow-lg">
      <div className="container mx-auto flex justify-between items-center">
        {/* Logo on the left */}
        <div className="flex items-center">
          <Link to="/" className="text-white text-xl font-bold">GetAHomePrice.com</Link>
        </div>

        {/* Navigation Links */}
        <div className="flex items-center space-x-6">
          <Link to="/about" className="text-white text-lg hover:text-gray-300 transition">
            About Us
          </Link>
          <Link to="/services" className="text-white text-lg hover:text-gray-300 transition">
            Services
          </Link>
          <Link to="/contact" className="text-white text-lg hover:text-gray-300 transition">
            Contact
          </Link>
          <Link to="/" className="text-white text-lg hover:text-gray-300 transition">
            Home
          </Link>

          {/* Conditional rendering based on token */}
          {token ? (
            <>
              <Link to="/dashboard" className="text-white text-lg hover:text-gray-300 transition">
                Dashboard
              </Link>
              <button
                onClick={handleLogout}
                className="text-white bg-red-500 px-4 py-2 rounded-lg hover:bg-red-600 transition"
              >
                Logout
              </button>
            </>
          ) : (
            <Link to="/login" className="text-white bg-green-500 px-4 py-2 rounded-lg hover:bg-green-600 transition">
              Login
            </Link>
          )}
        </div>
      </div>
    </nav>
  );
}

export default Navbar;

